import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { checkStepIsCompleted, getIncompletedStep } from 'src/app/Shared/commonMethods';
import { Globle } from 'src/app/Shared/global';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-price-quote-notes',
  templateUrl: './price-quote-notes.component.html',
  styleUrls: ['./price-quote-notes.component.css']
})
export class PriceQuoteNotesComponent implements OnInit {
  userID: any;
  appModel: any;
  SelectedTool: string;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  tokenKey: any;

  mainUrl: string;
  subUrl: string;

  priceQuoteId:number=0;
  isSubmit: boolean = false;
  isEdit: boolean = false;
  currentActiveTab: number = 1;
  notes:string;
  clientInformationId:number=0;
  companyId:number=0;

  constructor(private readonly activedRoute: ActivatedRoute, 
    private readonly globle: Globle,
    private readonly router: Router, 
    private readonly PricingQuotesMaster: PricingQuotesService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService) {
      this.SelectedTool = this.sessionStorageService.getUserLoginTool();
      this.userID = sessionStorage.getItem('UserId');
      this.tokenKey = this.sessionStorageService.getTokenValue();
      this.titleService.setTitle('Company Profile | JSi360');
      this.companyId=+sessionStorage.getItem('CompanyId');

      this.activedRoute.params.subscribe((params: Params) => {
        if (params['id']) {
          if (params['id'] != null) {
            this.clientInformationId = params['id'];
          }
        }
      });

      this.mainUrl = '/View/';
    if (this.clientInformationId != null) {
      this.GetProgressStepDetailsById(this.clientInformationId);
      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
    }
    else {
      this.globle.cApp.statusModel.isCompanyProfileDetailsCompleted = null;
      this.globle.cApp.statusModel.isAddCompQueCompleted = null;
      this.globle.cApp.statusModel.isStateSelectionCompleted = null;
      this.globle.cApp.statusModel.isNotes=null;
      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
    }

     }

  ngOnInit() {
    this.getPriceQuoteListByCompanyId(this.companyId)
  }

  getPriceQuoteListByCompanyId(companyId: number) {
    this.blockDocument();
    this.PricingQuotesMaster.getPriceQuoteListByCompanyId(this.tokenKey, companyId, false).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.unblockDocument();
          this.notes = result['pricingQuotes'][0].notes;
          this.priceQuoteId= result['pricingQuotes'][0].priceQuoteId;
        }
        else{
          this.unblockDocument();
        }
      });
  }

  save(clientForm: any) {
    this.isSubmit = true;
   
    let value = {
      clientInformationId: this.clientInformationId,
      priceQuoteId:this.priceQuoteId,
      notes:this.notes,
      createdBy:this.userID
    }

    this.blockDocument();
    this.PricingQuotesMaster.NotesAddUpdate(this.tokenKey, value).subscribe(
      result => {
        this.unblockDocument();
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel.isAddCompQueCompleted = true;
          this.unblockDocument();
          if (result['message'] != "") {
            this.showMessage(result['message'], 'Warning', 'warning')
          }
          else {
            this.showMessage('Company Profile saved successfully', 'success', 'success');
            this.router.navigate(['/View/client-profile']);
          }
        }
        else {
          this.unblockDocument();
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.unblockDocument();
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  previousStep() {
    // let navigation = '/admin/' + this.SelectedTool + '/company-info/' + this.clientInformationId;
    let navigation = '/View/state-selection/' + this.clientInformationId;
    this.router.navigate([navigation]);
  }

  nextStep() {
    // let navigation = '/admin/' + this.SelectedTool + '/state-selection';
    let navigation = '/View/state-selection';
    this.router.navigate([navigation]);
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  activeTab(url: string, tabId: number) {

    if (this.clientInformationId != null) {
      if (checkStepIsCompleted(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url + '/' + this.clientInformationId;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl + '/' + this.clientInformationId;
        this.router.navigate([navigate]);
      }
    }
    else {
      if (checkStepIsCompleted(url, this.globle.cApp.statusModel)) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + url;
        this.router.navigate([navigate]);
      }

      this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
      if (url == this.subUrl) {
        this.currentActiveTab = tabId;
        let navigate = this.mainUrl + this.subUrl;
        this.router.navigate([navigate]);
      }
    }
  }

  GetProgressStepDetailsById(clientInformationId: number) {
    this.PricingQuotesMaster.GetProgressStepDetailsByClientInformationId(this.tokenKey, this.clientInformationId).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.globle.cApp.statusModel = result['progress'];
          this.subUrl = getIncompletedStep(this.globle.cApp.statusModel);
          this.activeTab('notes', 13);
        }
      });
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

}
